/* unplugin-vue-components disabled */import script from "./recreationalvehicle.vue?vue&type=script&setup=true&lang=js"
export * from "./recreationalvehicle.vue?vue&type=script&setup=true&lang=js"

import "./recreationalvehicle.vue?vue&type=style&index=0&id=1714c2bd&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1714c2bd"]])

export default __exports__